export default __webpack_public_path__ + "static/media/svg-3.429df1d7.svg";